import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ParseWarning } from '../types';

interface ParseWarningsProps {
  warnings: ParseWarning[];
}

export function ParseWarnings({ warnings }: ParseWarningsProps) {
  const { t } = useTranslation('customer-onboarding');

  if (warnings.length === 0) return null;

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="mb-3 flex items-center gap-2">
        <AlertTriangle className="h-5 w-5 text-amber-600" />
        <h3 className="font-semibold text-amber-800">
          {t('warnings.title', { count: warnings.length })}
        </h3>
      </div>

      <p className="mb-3 text-sm text-amber-700">
        {t('warnings.description')}
      </p>

      <ul className="space-y-1 text-sm">
        {warnings.map((warning, index) => (
          <li key={index} className="flex gap-2 text-amber-800">
            <span className="text-amber-600">•</span>
            <span>
              {warning.entity !== 'general' && (
                <span className="font-medium capitalize">{warning.entity}</span>
              )}
              {warning.row != null && (
                <span className="text-amber-600"> (row {warning.row})</span>
              )}
              {warning.entity !== 'general' && ': '}
              {warning.messageKey
                ? t(`warnings.${warning.messageKey}`, { defaultValue: warning.message })
                : warning.message}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
